var map = {
	"./arrizo8/slider/slider-1.png": 4001,
	"./arrizo8/slider/slider-2.png": 8087,
	"./arrizo8/slider/slider-3.png": 1608,
	"./arrizo8/slider/slider-4.png": 5980,
	"./tiggo4pro/slider/slider-1.png": 5565,
	"./tiggo4pro/slider/slider-2.png": 8908,
	"./tiggo4pro/slider/slider-3.png": 894,
	"./tiggo4pro/slider/slider-4.png": 4126,
	"./tiggo7pro/slider/slider-1.png": 586,
	"./tiggo7pro/slider/slider-2.png": 7620,
	"./tiggo7pro/slider/slider-3.png": 9883,
	"./tiggo7pro/slider/slider-4.png": 4494,
	"./tiggo7promax/slider/slider-1.png": 9744,
	"./tiggo7promax/slider/slider-2.png": 725,
	"./tiggo7promax/slider/slider-3.png": 3573,
	"./tiggo7promax/slider/slider-4.png": 459,
	"./tiggo7proplugin/slider/slider-1.png": 9596,
	"./tiggo7proplugin/slider/slider-2.png": 27,
	"./tiggo7proplugin/slider/slider-3.png": 8032,
	"./tiggo7proplugin/slider/slider-4.png": 6829,
	"./tiggo8/slider/slider-1.png": 5685,
	"./tiggo8/slider/slider-2.png": 5443,
	"./tiggo8/slider/slider-3.png": 9254,
	"./tiggo8/slider/slider-4.png": 8163,
	"./tiggo8pro/slider/slider-1.png": 8025,
	"./tiggo8pro/slider/slider-2.png": 9538,
	"./tiggo8pro/slider/slider-3.png": 6577,
	"./tiggo8pro/slider/slider-4.png": 8682,
	"./tiggo8promax/slider/slider-1.png": 14,
	"./tiggo8promax/slider/slider-2.png": 876,
	"./tiggo8promax/slider/slider-3.png": 2963,
	"./tiggo8promax/slider/slider-4.png": 4122,
	"./tiggo8proplugin/slider/slider-1.png": 4081,
	"./tiggo8proplugin/slider/slider-2.png": 3507,
	"./tiggo8proplugin/slider/slider-3.png": 7035,
	"./tiggo8proplugin/slider/slider-4.png": 5931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6853;